var _mask, _path, _path2, _rect, _rect2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect3, _rect4, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEffortly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_942_573",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H98.6008C101.362 0 103.601 2.23858 103.601 5L103.601 12C101.95 12 100.612 13.3431 100.612 15C100.612 16.6569 101.95 18 103.601 18V86C101.95 86 100.612 87.3431 100.612 89C100.612 90.6569 101.95 92 103.601 92L103.601 100C103.601 102.761 101.362 105 98.6008 105H5C2.23858 105 0 102.761 0 100L1.07288e-05 92C1.6505 92 2.98849 90.6569 2.98849 89C2.98849 87.3431 1.6505 86 1.07288e-05 86V18C1.6505 18 2.98849 16.6569 2.98849 15C2.98849 13.3431 1.6505 12 1.07288e-05 12H0V5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H98.6008C101.362 0 103.601 2.23858 103.601 5L103.601 12C101.95 12 100.612 13.3431 100.612 15C100.612 16.6569 101.95 18 103.601 18V86C101.95 86 100.612 87.3431 100.612 89C100.612 90.6569 101.95 92 103.601 92L103.601 100C103.601 102.761 101.362 105 98.6008 105H5C2.23858 105 0 102.761 0 100L1.07288e-05 92C1.6505 92 2.98849 90.6569 2.98849 89C2.98849 87.3431 1.6505 86 1.07288e-05 86V18C1.6505 18 2.98849 16.6569 2.98849 15C2.98849 13.3431 1.6505 12 1.07288e-05 12H0V5Z",
    fill: "#8067DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.601 5H103.101V5L103.601 5ZM103.601 12V12.5H104.101V12L103.601 12ZM103.601 18H104.101V17.5H103.601V18ZM103.601 86V86.5H104.101V86H103.601ZM103.601 92H104.101V91.5H103.601V92ZM103.601 100H103.101H103.601ZM0 100H-0.5H0ZM1.07288e-05 92V91.5H-0.499989L-0.499989 92H1.07288e-05ZM1.07288e-05 86H-0.499989V86.5H1.07288e-05V86ZM1.07288e-05 18V17.5H-0.499989V18H1.07288e-05ZM0 12H-0.5V12.5H0V12ZM5 -0.5C1.96243 -0.5 -0.5 1.96243 -0.5 5H0.5C0.5 2.51472 2.51472 0.5 5 0.5V-0.5ZM98.6008 -0.5H5V0.5H98.6008V-0.5ZM104.101 5C104.101 1.96243 101.638 -0.5 98.6008 -0.5V0.5C101.086 0.5 103.101 2.51472 103.101 5H104.101ZM104.101 12L104.101 5L103.101 5L103.101 12L104.101 12ZM101.112 15C101.112 13.6175 102.228 12.5 103.601 12.5V11.5C101.672 11.5 100.112 13.0688 100.112 15H101.112ZM103.601 17.5C102.228 17.5 101.112 16.3825 101.112 15H100.112C100.112 16.9312 101.672 18.5 103.601 18.5V17.5ZM104.101 86V18H103.101V86H104.101ZM101.112 89C101.112 87.6175 102.228 86.5 103.601 86.5V85.5C101.672 85.5 100.112 87.0688 100.112 89H101.112ZM103.601 91.5C102.228 91.5 101.112 90.3825 101.112 89H100.112C100.112 90.9312 101.672 92.5 103.601 92.5V91.5ZM104.101 100L104.101 92H103.101L103.101 100H104.101ZM98.6008 105.5C101.638 105.5 104.101 103.038 104.101 100H103.101C103.101 102.485 101.086 104.5 98.6008 104.5V105.5ZM5 105.5H98.6008V104.5H5V105.5ZM-0.5 100C-0.5 103.038 1.96243 105.5 5 105.5V104.5C2.51472 104.5 0.5 102.485 0.5 100H-0.5ZM-0.499989 92L-0.5 100H0.5L0.500011 92H-0.499989ZM2.48849 89C2.48849 90.3825 1.37255 91.5 1.07288e-05 91.5V92.5C1.92846 92.5 3.48849 90.9312 3.48849 89H2.48849ZM1.07288e-05 86.5C1.37255 86.5 2.48849 87.6175 2.48849 89H3.48849C3.48849 87.0688 1.92846 85.5 1.07288e-05 85.5V86.5ZM-0.499989 18V86H0.500011V18H-0.499989ZM2.48849 15C2.48849 16.3825 1.37255 17.5 1.07288e-05 17.5V18.5C1.92846 18.5 3.48849 16.9312 3.48849 15H2.48849ZM1.07288e-05 12.5C1.37255 12.5 2.48849 13.6175 2.48849 15H3.48849C3.48849 13.0688 1.92846 11.5 1.07288e-05 11.5V12.5ZM0 12.5H1.07288e-05V11.5H0V12.5ZM-0.5 5V12H0.5V5H-0.5Z",
    fill: "white",
    mask: "url(#path-1-inside-1_942_573)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.4542,
    y: 12.5,
    width: 78.6929,
    height: 79,
    rx: 9.5,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4385,
    y: 16.5,
    width: 70.7236,
    height: 71,
    rx: 6.5,
    fill: "white",
    stroke: "#F3F3F3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.4062,
    cy: 24.5,
    rx: 1.49424,
    ry: 1.5,
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.4062,
    cy: 79.5,
    rx: 1.49424,
    ry: 1.5,
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.1954,
    cy: 24.5,
    rx: 1.49424,
    ry: 1.5,
    fill: "#D9D9D9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.1954,
    cy: 79.5,
    rx: 1.49424,
    ry: 1.5,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.8544,
    y: 23,
    width: 28.8887,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.8544,
    y: 78,
    width: 28.8887,
    height: 3,
    rx: 1.5,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0183 41.1985C71.1107 41.3033 71.1454 41.4463 71.1107 41.5816L69.6919 47.2029C69.6418 47.4126 69.3646 47.4755 69.226 47.3059L68.3674 46.3013C68.2172 46.124 67.9516 46.0992 67.7687 46.2422L53.7094 57.3171C52.9105 57.9404 51.7515 57.8261 51.0912 57.0522L48.6001 54.1109C48.4519 53.9356 48.19 53.907 48.0052 54.0461C45.876 55.6626 43.7507 57.2809 41.6215 58.8973C41.3982 59.067 41.0747 58.985 40.9631 58.7296L39.8446 56.2077C39.7656 56.0304 39.8176 55.8227 39.9697 55.7026C42.4589 53.7144 44.9404 51.7358 47.4296 49.7477C48.2285 49.1167 49.3875 49.2311 50.0478 50.0031L52.5351 52.9386C52.6852 53.1159 52.9528 53.1426 53.1357 52.9977L65.3103 43.4058C65.5009 43.2552 65.5278 42.9788 65.3719 42.7939L64.65 41.9495C64.5113 41.7875 64.6153 41.5244 64.8386 41.5054L70.6641 41.0479C70.8008 41.0364 70.9355 41.0917 71.0241 41.1946L71.0183 41.1985Z",
    fill: "#DC67CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6667 62.3879C52.7326 62.7466 51.7288 62.9777 50.6747 63.0585C44.828 63.5074 39.7065 59.1364 39.4802 53.3792C39.2694 47.9488 43.7372 43.4126 48.9379 42.9636C52.8118 42.6293 56.6645 44.6016 58.8791 48.0277C60.1613 47.0341 61.4456 46.0385 62.7279 45.0449C61.9349 43.8934 58.7649 39.5807 52.9202 38.3635C49.9127 37.7361 47.5144 38.2207 46.7911 38.3616C39.869 39.7009 34.6934 45.6403 34.4749 52.4926C34.1867 61.5426 42.041 68.5978 51.0673 67.9028C54.1328 67.6661 56.9237 66.5691 59.1962 64.873C59.3974 64.7227 59.4264 64.4391 59.2581 64.255L56.5466 61.2947C56.3744 61.1049 56.0824 61.0749 55.8716 61.2233C55.1946 61.6929 54.4558 62.0855 53.6648 62.3879H53.6667Z",
    fill: "#8067DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffortly);
export default __webpack_public_path__ + "static/media/effortly.1e06763b1d67a5e850ad0fda06f1e5cd.svg";
export { ForwardRef as ReactComponent };